import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-2021/uxp-photoshop-2021/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "selection"
    }}>{`Selection`}</h1>
    <h2 {...{
      "id": "implements"
    }}>{`Implements`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></li>
    </ul>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "bounds"
    }}>{`bounds`}</h3>
    <p>{`• `}<strong parentName="p">{`bounds`}</strong>{`: `}<em parentName="p">{`Promise‹PsCommon.Bounds›`}</em></p>
    <p>{`The selection's rectangular bounds`}</p>
    <hr></hr>
    <h3 {...{
      "id": "parent"
    }}>{`parent`}</h3>
    <p>{`• `}<strong parentName="p">{`parent`}</strong>{`: `}<em parentName="p">{`Promise‹`}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/classes/document/"
        }}>{`Document`}</a>{`›`}</em></p>
    <p>{`The document this selection belongs to`}</p>
    <hr></hr>
    <h3 {...{
      "id": "solid"
    }}>{`solid`}</h3>
    <p>{`• `}<strong parentName="p">{`solid`}</strong>{`: `}<em parentName="p">{`Promise‹boolean›`}</em></p>
    <p>{`Whether the selection is solid`}</p>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "copy"
    }}>{`copy`}</h3>
    <p>{`▸ `}<strong parentName="p">{`copy`}</strong>{`(`}<inlineCode parentName="p">{`merge?`}</inlineCode>{`: boolean): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p>{`Invoke a copy command on the selection`}</p>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`merge?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Copy merged contents of all visible layers`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "cut"
    }}>{`cut`}</h3>
    <p>{`▸ `}<strong parentName="p">{`cut`}</strong>{`(): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p>{`Invoke a cut command on the selection`}</p>
    <hr></hr>
    <h3 {...{
      "id": "expand"
    }}>{`expand`}</h3>
    <p>{`▸ `}<strong parentName="p">{`expand`}</strong>{`(`}<inlineCode parentName="p">{`amount?`}</inlineCode>{`: number): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p>{`Expands the selection by a pixel amount`}</p>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`amount?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pixels to expand by`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "feather"
    }}>{`feather`}</h3>
    <p>{`▸ `}<strong parentName="p">{`feather`}</strong>{`(`}<inlineCode parentName="p">{`amount?`}</inlineCode>{`: number): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p>{`Feathers the selection by a pixel amount`}</p>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`amount?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pixels to feather by`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "invert"
    }}>{`invert`}</h3>
    <p>{`▸ `}<strong parentName="p">{`invert`}</strong>{`(): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p>{`Invert the selection`}</p>
    <hr></hr>
    <h3 {...{
      "id": "nudge"
    }}>{`nudge`}</h3>
    <p>{`▸ `}<strong parentName="p">{`nudge`}</strong>{`(`}<inlineCode parentName="p">{`horizontal`}</inlineCode>{`: number | PercentValue | PixelValue, `}<inlineCode parentName="p">{`vertical`}</inlineCode>{`: number | PercentValue | PixelValue): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p><em parentName="p">{`Implementation of `}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></em></p>
    <p>{`Moves the selected pixels.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// nudge the selection to the left by 200px
await selection.nudge(-200, 0)
`}</code></pre>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`horizontal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` PercentValue `}{`|`}{` PixelValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Numeric value to offset selection content by in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`vertical`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` PercentValue `}{`|`}{` PixelValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Numeric value to offset selection content by in pixels`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "perspectivetransform"
    }}>{`perspectiveTransform`}</h3>
    <p>{`▸ `}<strong parentName="p">{`perspectiveTransform`}</strong>{`(`}<inlineCode parentName="p">{`percentH`}</inlineCode>{`: number | PercentValue, `}<inlineCode parentName="p">{`percentV`}</inlineCode>{`: number | PercentValue, `}<inlineCode parentName="p">{`interpolation?`}</inlineCode>{`: InterpolationMethod): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p><em parentName="p">{`Implementation of `}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></em></p>
    <p>{`Applies a distortion (perspective) to the content under the selection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// 'into the distance' effect
await selection.perspectiveTransform(0, -0.05)
`}</code></pre>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`percentH`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` PercentValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Distortion factor in the horizontal axis (percent)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`percentV`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` PercentValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Distortion factor in the vertical axis (percent)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`InterpolationMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interpolation method to use when resampling the image @default InterpolationMethod.bilinear`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "rotate"
    }}>{`rotate`}</h3>
    <p>{`▸ `}<strong parentName="p">{`rotate`}</strong>{`(`}<inlineCode parentName="p">{`angle`}</inlineCode>{`: number | AngleValue, `}<inlineCode parentName="p">{`interpolation?`}</inlineCode>{`: InterpolationMethod): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p><em parentName="p">{`Implementation of `}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></em></p>
    <p>{`Rotates the content under the selection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// rotate 90 deg counter clockwise
await selection.rotate(-90)
`}</code></pre>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`angle`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` AngleValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Angle to rotate the selection content by in degrees`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`InterpolationMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interpolation method to use when resampling the image @default InterpolationMethod.bilinear`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "scale"
    }}>{`scale`}</h3>
    <p>{`▸ `}<strong parentName="p">{`scale`}</strong>{`(`}<inlineCode parentName="p">{`width`}</inlineCode>{`: number | PercentValue, `}<inlineCode parentName="p">{`height`}</inlineCode>{`: number | PercentValue, `}<inlineCode parentName="p">{`interpolation?`}</inlineCode>{`: InterpolationMethod): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p><em parentName="p">{`Implementation of `}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></em></p>
    <p>{`Scales the content under the selection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await selection.scale(120, 120)
`}</code></pre>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`width`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` PercentValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Numeric percentage to scale selection content horizontally`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`height`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` PercentValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Numeric percentage to scale selection content vertically`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`InterpolationMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interpolation method to use when resampling the image @default InterpolationMethod.bilinear `}<inlineCode parentName="td">{` * > Should this default follow the user preferences?`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "skew"
    }}>{`skew`}</h3>
    <p>{`▸ `}<strong parentName="p">{`skew`}</strong>{`(`}<inlineCode parentName="p">{`angleH`}</inlineCode>{`: number | AngleValue, `}<inlineCode parentName="p">{`angleV`}</inlineCode>{`: number | AngleValue, `}<inlineCode parentName="p">{`interpolation?`}</inlineCode>{`: InterpolationMethod): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p><em parentName="p">{`Implementation of `}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></em></p>
    <p>{`Applies a skew to the content under the selection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// parellelogram shape
await selection.skew(-15, 0)
`}</code></pre>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`angleH`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` AngleValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Horizontal angle to skew by`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`angleV`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number `}{`|`}{` AngleValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Vertical angle to skew by`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`InterpolationMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interpolation method to use when resampling the image @default InterpolationMethod.bilinear`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "translate"
    }}>{`translate`}</h3>
    <p>{`▸ `}<strong parentName="p">{`translate`}</strong>{`(`}<inlineCode parentName="p">{`deltaX`}</inlineCode>{`: number, `}<inlineCode parentName="p">{`deltaY`}</inlineCode>{`: number): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p>{`Translate the entire selection.`}</p>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`deltaX`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Amount to move selection to the right, in pixels`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`deltaY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Amount to move selection down, in pixels`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "warp"
    }}>{`warp`}</h3>
    <p>{`▸ `}<strong parentName="p">{`warp`}</strong>{`(`}<inlineCode parentName="p">{`warp`}</inlineCode>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2021/ps_reference/interfaces/builtinwarp/"
      }}>{`BuiltinWarp`}</a>{` | `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2021/ps_reference/interfaces/customwarp4x4/"
      }}>{`CustomWarp4X4`}</a>{`, `}<inlineCode parentName="p">{`interpolation?`}</inlineCode>{`: InterpolationMethod): `}<em parentName="p">{`Promise‹void›`}</em></p>
    <p><em parentName="p">{`Implementation of `}<a parentName="em" {...{
          "href": "/photoshop/uxp/2021/ps_reference/interfaces/transformable/"
        }}>{`Transformable`}</a></em></p>
    <p>{`Applies a warp to the content under the selection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// perform a fisheye warp
await selection.warp({ style: BuiltinWarpStyle.warpFisheye, value: 70 })

// warp selection content using a user provided 4x4 warp grid of points
var bounds = await selection.bounds
var grid = myWarpEngine.generateUniformXYPoints(bounds, 16)
var warp = myWarpEngine.applyWarp(grid)
await selection.warp({ meshPoints: warp })
`}</code></pre>
    <p><strong parentName="p">{`Parameters:`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`warp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/2021/ps_reference/interfaces/builtinwarp/"
            }}>{`BuiltinWarp`}</a>{` `}{`|`}{` `}<a parentName="td" {...{
              "href": "/photoshop/uxp/2021/ps_reference/interfaces/customwarp4x4/"
            }}>{`CustomWarp4X4`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Warp definition`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`interpolation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`InterpolationMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interpolation method to use when resampling the image @default InterpolationMethod.bilinear`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      